import { addTask } from "../utils/bugFixer";
import { Action, Reducer } from "redux";
import * as Api from "../api/api";
import * as Notifications from 'react-notification-system-redux';
import { AppThunkAction } from "./";
import { getDefaultHeaders } from "../utils/utils";
import {getText} from "../utils/langTexts";

export interface CarrierRatesSettingsState {
    isLoading: boolean;
    requestTime?: number;
    selectedId?: number;
    entities: Array<Api.CarrierRatesSettingsModel>;
    createState: {
        isLoading: boolean;
        requestTime?: number;
    };
    updateState: {
        [id: number]: {
            isLoading: boolean;
            requestTime?: number;
        }
    }
    deleteState: {
        [id: number]: {
            isLoading: boolean;
            requestTime?: number;
        }
    };
}

interface RequestCarrierRatesSettingsEntities {
    type: "REQUEST_CARRIERRATESSETTINGS_ENTITIES";
    payload: { requestTime: number };
}
interface ReceiveCarrierRatesSettingsEntities {
    type: "RECEIVE_CARRIERRATESSETTINGS_ENTITIES";
    payload: { requestTime: number; entities?: Array<Api.CarrierRatesSettingsModel> };
    error?: any;
}

interface RequestCarrierRatesSettingsCreate {
    type: "REQUEST_CARRIERRATESSETTINGS_CREATE";
    payload: { requestTime: number };
}
interface ReceiveCarrierRatesSettingsCreate {
    type: "RECEIVE_CARRIERRATESSETTINGS_CREATE";
    payload: { requestTime: number; entity?: Api.CarrierRatesSettingsModel };
    error?: any;
}

interface RequestCarrierRatesSettingsUpdate {
    type: "REQUEST_CARRIERRATESSETTINGS_UPDATE";
    payload: { requestTime: number; id: number; };
}
interface ReceiveCarrierRatesSettingsUpdate {
    type: "RECEIVE_CARRIERRATESSETTINGS_UPDATE";
    payload: { requestTime: number; id: number; entity?: Api.CarrierRatesSettingsModel };
    error?: any;
}

interface RequestCarrierRatesSettingsDelete {
    type: "REQUEST_CARRIERRATESSETTINGS_DELETE";
    payload: { requestTime: number; id: number; };
}
interface ReceiveCarrierRatesSettingsDelete {
    type: "RECEIVE_CARRIERRATESSETTINGS_DELETE";
    payload: { requestTime: number; id: number; };
    error?: any;
}

interface UpdateCarrierRatesSettingsSelectedId {
    type: "UPDATE_CARRIERRATESSETTINGS_SELECTEDID";
    payload: { value: number; };
}

export type KnownAction = RequestCarrierRatesSettingsEntities
    | ReceiveCarrierRatesSettingsEntities
    | RequestCarrierRatesSettingsCreate
    | ReceiveCarrierRatesSettingsCreate
    | RequestCarrierRatesSettingsUpdate
    | ReceiveCarrierRatesSettingsUpdate
    | RequestCarrierRatesSettingsDelete
    | ReceiveCarrierRatesSettingsDelete
    | UpdateCarrierRatesSettingsSelectedId
    ;

export const actionCreators = {
    requestCarrierRatesSettings: (requestTime: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesSettingsApi();
        let fetch = api.getEntities({ credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entities => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_ENTITIES",
                    payload: { requestTime: requestTime, entities: entities }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_ENTITIES",
                    payload: { requestTime: requestTime, },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESSETTINGS_ENTITIES",
            payload: { requestTime: requestTime }
        });
        addTask(fetch);
        return fetch;
    },
    requestCreateCarrierRatesSettings: (requestTime: number, model: Api.CarrierRatesSettingsModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesSettingsApi();
        let fetch = api.create({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_CREATE",
                    payload: { requestTime: requestTime, entity: entity }
                });
                dispatch(Notifications.success({ message: getText("GenCarrierQuotesSettingsCreateSuccess"), title: getText("GenSuccess"), position: "tc" }) as any);
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_CREATE",
                    payload: { requestTime: requestTime, },
                    error: err
                });
                dispatch(Notifications.error({ message: getText("GenCarrierQuotesSettingsCreateFailure"), title: getText("GenError"), position: "tc" }) as any);
            });

        dispatch({
            type: "REQUEST_CARRIERRATESSETTINGS_CREATE",
            payload: { requestTime: requestTime }
        });
        return fetch;
    },
    requestUpdateCarrierRatesSettings: (requestTime: number, model: Api.CarrierRatesSettingsModel): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesSettingsApi();
        let fetch = api.update({ model: model }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(entity => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_UPDATE",
                    payload: { requestTime: requestTime, id: model.carrierRatesSettingsId, entity: entity }
                });
                dispatch(Notifications.success({ message: getText("GenCarrierQuotesSettingsUpdateSuccess"), title: getText("GenSuccess"), position: "tc" }) as any);
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_UPDATE",
                    payload: { requestTime: requestTime, id: model.carrierRatesSettingsId },
                    error: err
                });
                dispatch(Notifications.error({ message: getText("GenCarrierQuotesSettingsUpdateFailure"), title: getText("GenError"), position: "tc" }) as any);
            });

        dispatch({
            type: "REQUEST_CARRIERRATESSETTINGS_UPDATE",
            payload: { requestTime: requestTime, id: model.carrierRatesSettingsId }
        });
        return fetch;
    },
    requestDeleteCarrierRatesSettings: (requestTime: number, id: number): AppThunkAction<KnownAction, Promise<any>> => (dispatch, getState) => {
        let api = new Api.CarrierRatesSettingsApi();
        let fetch = api._delete({ id: id }, { credentials: "same-origin", headers: getDefaultHeaders(getState()) })
            .then(() => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_DELETE",
                    payload: { requestTime: requestTime, id: id }
                });
            })
            .catch(err => {
                dispatch({
                    type: "RECEIVE_CARRIERRATESSETTINGS_DELETE",
                    payload: { requestTime: requestTime, id: id },
                    error: err
                });
            });

        dispatch({
            type: "REQUEST_CARRIERRATESSETTINGS_DELETE",
            payload: { requestTime: requestTime, id: id }
        });
        return fetch;
    },
    updateCarrierRatesSettingsSelectedId: (id: number) => <UpdateCarrierRatesSettingsSelectedId>{
        type: "UPDATE_CARRIERRATESSETTINGS_SELECTEDID",
        payload: { value: id }
    }
};


const unloadedState: CarrierRatesSettingsState = {
    isLoading: false,
    createState: {
        isLoading: false
    },
    deleteState: {},
    updateState: {},
    entities: []
};


export const reducer: Reducer<CarrierRatesSettingsState> = (state: CarrierRatesSettingsState, incomingAction: Action) => {
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case "REQUEST_CARRIERRATESSETTINGS_ENTITIES":
            return {
                ...state,
                isLoading: true,
                requestTime: action.payload.requestTime
            };
        case "RECEIVE_CARRIERRATESSETTINGS_ENTITIES":
            if (state.requestTime !== action.payload.requestTime)
                return state;

            return {
                ...state,
                isLoading: false,
                entities: action.error
                    ? state.entities
                    : action.payload.entities
            };
        case "REQUEST_CARRIERRATESSETTINGS_CREATE":
            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: true,
                    requestTime: action.payload.requestTime
                }
            };
        case "RECEIVE_CARRIERRATESSETTINGS_CREATE":
            if (action.payload.requestTime !== state.createState.requestTime)
                return state;

            return {
                ...state,
                createState: {
                    ...state.createState,
                    isLoading: false,
                },
                entities: action.error
                    ? state.entities
                    : state.entities.concat([action.payload.entity])
            };
        case "REQUEST_CARRIERRATESSETTINGS_UPDATE":
            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_CARRIERRATESSETTINGS_UPDATE":
            if (!state.updateState[action.payload.id]
                || action.payload.requestTime !== state.updateState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                updateState: {
                    ...state.updateState,
                    [action.payload.id]: {
                        ...state.updateState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                },
                entities: action.error
                    ? state.entities
                    : state.entities.map(x => x.carrierRatesSettingsId === action.payload.entity.carrierRatesSettingsId
                        ? { ...x, ...action.payload.entity }
                        : x)
            };
        case "REQUEST_CARRIERRATESSETTINGS_DELETE":
            return {
                ...state,
                deleteState: {
                    ...state.deleteState,
                    [action.payload.id]: {
                        ...state.deleteState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                }
            };
        case "RECEIVE_CARRIERRATESSETTINGS_DELETE":
            if (!state.deleteState[action.payload.id]
                || action.payload.requestTime !== state.deleteState[action.payload.id].requestTime)
                return state;

            return {
                ...state,
                deleteState: {
                    ...state.deleteState,
                    [action.payload.id]: {
                        ...state.deleteState[action.payload.id],
                        isLoading: true,
                        requestTime: action.payload.requestTime
                    }
                },
                selectedId: action.payload.id === state.selectedId
                    ? undefined
                    : state.selectedId,
                entities: action.error
                    ? state.entities
                    : state.entities.filter(x => x.carrierRatesSettingsId !== action.payload.id)
            };
        case "UPDATE_CARRIERRATESSETTINGS_SELECTEDID":
            return {
                ...state,
                selectedId: action.payload.value
            };
        default:
            // The following line guarantees that every action in the KnownAction union has been covered by a case above
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state || unloadedState;
};